import { useEffect, useState } from 'react';
import _ from 'lodash';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { Button, Grid, TextInput, Modal, Typography, IconButton, Icon } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

interface IListValuesDefinition extends IForm {
  defaultValues: any[];
  fixList?: boolean; //Disable all actions
}

const ListValuesDefinition = (props: IListValuesDefinition) => {
  const { values, mode, onCallbackChange } = props;
  const isViewMode = mode === 'view';

  const [showModal, setShowModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [idxToDelete, setIdxToDelete] = useState();

  const _handleDeletePS = idx => {
    const possibleValues = [...values.possibleValues];
    possibleValues.splice(idx, 1);
    onCallbackChange('possibleValues')(possibleValues);
  };

  const _onValueSet = stateName => {
    const possibleValues = _.get(props, 'values.possibleValues', []);
    const newPossibleValues = [...possibleValues];
    if (!newPossibleValues.includes(stateName)) {
      newPossibleValues.push(stateName);
      onCallbackChange('possibleValues')(newPossibleValues);
    }
    setShowModal(false);
  };

  const possibleValues = values.possibleValues ?? props.defaultValues;
  let rows = _.map(possibleValues, (value, idx) => {
    return (
      <TableRow key={idx}>
        <TableCell>{value.toString()}</TableCell>
        <TableCell align="right">
          <IconButton
            onClick={() => {
              setShowConfirmationModal(true);
              setIdxToDelete(idx);
            }}
            disabled={isViewMode || props.fixList}
          >
            <Icon icon="action-delete" />
          </IconButton>
        </TableCell>
      </TableRow>
    );
  });

  useEffect(() => {
    if (props.values.type === 'boolean') onCallbackChange('possibleValues')(props.defaultValues);
  }, [props.values.type]);

  const [stateName, setStateName] = useState('');

  return (
    <>
      <Typography variant="h6" text="Possible states of this indicator" />
      <Table size="small">
        <TableBody>{rows}</TableBody>
      </Table>
      <br />
      {!(isViewMode || props.fixList) && (
        <Button
          label="Add possible state"
          variant="outlined"
          onClick={() => setShowModal(true)}
          disabled={props.mode == 'view'}
        />
      )}
      <Modal
        withHeader
        title="Confirm deletion"
        open={showConfirmationModal}
        labelCancel="Cancel"
        labelOk="Delete"
        onClose={() => setShowConfirmationModal(false)}
        warningToShow="Are you sure you want to delete this value? This action cannot be undone."
        onSubmit={() => {
          _handleDeletePS(idxToDelete);
          setShowConfirmationModal(false);
        }}
        fullWidth
        maxWidth="xs"
      />
      <Modal
        withHeader
        title="Add a possible state for this indicator"
        open={showModal}
        labelOk="Add"
        onClose={() => setShowModal(false)}
        disabled={stateName === ''}
        onSubmit={() => _onValueSet(stateName)}
      >
        <Grid container p={2} sx={{ width: '500px' }}>
          <Grid size={12}>
            <TextInput
              label="Write the name of the state"
              value={stateName}
              onChangeValue={v => setStateName(v.toString())}
              disabled={props.mode == 'view'}
              focus
            />
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default ListValuesDefinition;
